import { getBasicUserInfo } from "@/api/auth";
import { isUnifiedShellOn, ROLLOUT_MODE } from "./userTypes";

/** Reads the rollout switch from this browser and the rollout stage. See isUnifiedShellOn. */
export function useUnifiedShell(): boolean {
  let override: string | null = null;
  try {
    override = localStorage.getItem("unifiedShell");
  } catch {
    /* storage blocked — fall through to the default */
  }
  return isUnifiedShellOn({ email: getBasicUserInfo()?.email, override, mode: ROLLOUT_MODE });
}
